import React, { useState } from "react";
import pbsConnectLogo from "../Assets/Logo/PBS Connect logo.svg";
import pbsConnectLogoWhite from "../Assets/Logo/PBS Connect logo white.svg";
import { useMsal } from "@azure/msal-react";

const SignIn: React.FC = () => {
  const { instance } = useMsal();
  const [isSigningIn, setIsSigningIn] = useState(false);

  const handleSignIn = () => {
    if (isSigningIn) return;
    setIsSigningIn(true);
    instance.loginRedirect().catch((error) => {
      console.error("Error starting sign-in redirect:", error);
      setIsSigningIn(false);
    });
  };
  return (
    <div className="signin-hero relative flex min-h-screen">
      {/* Brand panel: dark navy in light theme (matches PBS LMS), flips to
          the same off-white as PBS Stream in dark theme. Colors come from
          --signin-* vars (defined in App.css from the live sibling apps'
          own tokens), not this app's own --foreground/--background, so the
          rest of the app's theme is untouched and this stays pixel-exact. */}
      <section className="bg-[var(--signin-fg)] text-[var(--signin-bg)] relative hidden flex-1 flex-col justify-between overflow-hidden p-12 lg:flex">
        <div className="absolute inset-0 opacity-[0.03]" aria-hidden="true">
          <div
            className="h-full w-full"
            style={{
              backgroundImage:
                "linear-gradient(currentcolor 1px, transparent 1px), linear-gradient(90deg, currentcolor 1px, transparent 1px)",
              backgroundSize: "60px 60px",
            }}
          />
        </div>

        <div
          className="bg-[var(--signin-primary-glow)] absolute -top-20 -right-20 h-80 w-80 rounded-full blur-3xl"
          aria-hidden="true"
        />
        <div
          className="bg-[var(--signin-accent-glow)] absolute -bottom-32 -left-32 h-96 w-96 rounded-full blur-3xl"
          aria-hidden="true"
        />

        <div className="relative z-10">
          <img
            src={pbsConnectLogoWhite}
            alt="PBS Connect"
            className="block h-11 w-auto dark:hidden"
          />
          <img
            src={pbsConnectLogo}
            alt="PBS Connect"
            className="hidden h-11 w-auto dark:block"
          />
        </div>

        <div className="relative z-10 max-w-md space-y-4">
          <h1 className="text-4xl leading-tight font-bold tracking-tight">
            View, manage, edit
            <br />
            &mdash; one place.
          </h1>
          <p className="text-[var(--signin-bg-60)] text-lg leading-relaxed font-semibold">
            The Team PBS Profile hub for viewing, managing, and editing your
            profile and documents.
          </p>
        </div>

        <div className="text-[var(--signin-bg-30)] relative z-10 text-sm font-semibold">
          &copy; {new Date().getFullYear()} Team PBS
        </div>
      </section>

      {/* Form panel: exact inverse of the brand panel above (bg/fg swapped),
          same --signin-* vars, so it always contrasts and always matches. */}
      <main className="flex flex-1 flex-col lg:max-w-xl bg-[var(--signin-bg)] text-[var(--signin-fg)]">
        <div className="flex items-center px-6 py-4 lg:hidden">
          <img
            src={pbsConnectLogo}
            alt="PBS Connect"
            className="block h-10 w-auto dark:hidden"
          />
          <img
            src={pbsConnectLogoWhite}
            alt="PBS Connect"
            className="hidden h-10 w-auto dark:block"
          />
        </div>

        <div className="flex flex-1 items-center justify-center px-6">
          <div className="w-full max-w-sm space-y-5">
            <div className="space-y-2">
              <h2 className="text-2xl font-bold tracking-tight">Sign in</h2>
              <p className="text-[var(--signin-muted)] text-base font-semibold">
                Use your Team PBS Microsoft account to access PBS Connect.
              </p>
            </div>

            <button
              type="button"
              onClick={handleSignIn}
              disabled={isSigningIn}
              className="inline-flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-[var(--signin-primary)] px-6 text-sm font-semibold text-[var(--signin-primary-foreground)] transition-opacity hover:opacity-90 disabled:pointer-events-none disabled:opacity-50"
            >
              <svg
                className="h-5 w-5"
                viewBox="0 0 21 21"
                fill="none"
                aria-hidden="true"
              >
                <rect x="1" y="1" width="9" height="9" fill="#F25022" />
                <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
                <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
                <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
              </svg>
              {isSigningIn ? "Redirecting..." : "Sign in with Microsoft"}
            </button>

            <p className="text-[var(--signin-muted)] text-center text-xs font-semibold">
              Access is restricted to authorized Team PBS members.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};
export default SignIn;
